import { HugeiconsIcon } from '@hugeicons/react';
import { Divider, Stack, Typography } from '@mui/material';
import { ReactNode } from 'react';

interface Props {
  title: string;
  icon: ReactNode;
  quantity?: number;
}

const OrderStageHeader = ({ title, icon, quantity }: Props) => {
  return (
    <Stack>
      <Stack
        p={2}
        direction={'row'}
        alignItems={'center'}
        justifyContent={'space-between'}
      >
        <Stack direction={'row'} alignItems={'center'} spacing={2}>
          <HugeiconsIcon icon={icon} />
          <Typography>{title}</Typography>
        </Stack>
        <Typography>{quantity}</Typography>
      </Stack>
      <Divider />
    </Stack>
  );
};

export default OrderStageHeader;
